import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../axios";
import config from "../../../config";
import { Col, Empty, Row, Spin } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { usePersistedStore } from '../../../store/persisted-store';
import { useReportsStore } from '../../../store/slices/createReportsSlice';

function InsuranceHistoryLog(props) {
    const { business } = usePersistedStore();
    const reports = useReportsStore()
    const [historyList, setHistoryList] = useState([]);
    const token = business.currentBusiness.token;
    const requestId = reports.insuranceDetails.infos.InsuranceRequestId;


    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (props.tab == 4) {
            setLoading(true)
            const resp = axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/insurance/${requestId}/info-history`,
                headers: {
                    token
                },
            })
                .then((resp) => {
                    setHistoryList(resp.data)
                    setLoading(false)
                })
                .catch(e => {
                    setLoading(false)
                })

        }
    }, [props.tab]);

    return (
        <Spin spinning={loading}>
            {historyList.length > 0 ?
                <div className='log-history-section'>
                    {historyList.map((history, index) => {
                        return (<Row className='main-row'>
                            <Col span={11}>
                                {history?.Histories?.map((item, key) => {
                                    if (key < 9) {
                                        return (<Row className='inner-row'>
                                            <Col span={12}>
                                                <strong>
                                                    {item?.Title}
                                                </strong>
                                            </Col>
                                            <Col span={1}>
                                                <div className='v-line-smal'></div>
                                            </Col>
                                            {item?.Title == "توضیحات" ?
                                                <Col span={11}>
                                                    <TextArea>
                                                        {item?.Value}
                                                    </TextArea>
                                                </Col>
                                                :
                                                <Col span={11}>
                                                    {item?.Value == "True" ? "بله" : item?.Value == "False" ? "خیر" : item.Value}
                                                </Col>

                                            }
                                        </Row>)
                                    }
                                })}
                            </Col>
                            <Col span={2}>
                                <div className='v-line'></div>
                            </Col>
                            <Col span={11}>
                                {history?.Histories?.map((item, key) => {
                                    if (key >= 9) {
                                        return (<Row className='inner-row'>
                                            <Col span={12}>
                                                <strong>
                                                    {item?.Title}
                                                </strong>
                                            </Col>
                                            <Col span={1}>
                                                <div className='v-line-smal'></div>
                                            </Col>
                                            {item?.Title == "توضیحات" ?
                                                <TextArea>
                                                    {item?.Value}
                                                </TextArea>
                                                :
                                                <Col span={11}>
                                                    {item?.Value == "True" ? "بله" : item?.Value == "False" ? "خیر" : item.Value}
                                                </Col>

                                            }
                                        </Row>)
                                    }
                                })}
                            </Col>
                        </Row>)
                    })}
                </div >
                :
                <Empty description={false} />
            }
        </Spin >
    )
}

export default InsuranceHistoryLog